import { firebaseFunctionsUrl } from "./FirebaseEnvironments";

export const getTranscript = async (imageUrl: string) => {
  const functionUrl = firebaseFunctionsUrl('ocr ');
  const response = await fetch(`${functionUrl}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ imageUrl }),
  });
  const { text } = await response.json();
  const html = text
    .split(/\.\s*/)
    .map(paragraph => paragraph.trim())
    .filter(paragraph => paragraph.length > 0)
    .map(paragraph => `<p>${paragraph}.</p>`)
    .join('');
  return html;
};